import { create } from 'zustand'
import type { AppScreen, GameHudView, GameModeId, RoundResult } from '@/gameplay/types'
import { loadSettings, saveSettings, type PlayerSettings } from '@/persistence/settings'

interface AppState {
  screen: AppScreen
  mode: GameModeId
  mapId: string | null
  settings: PlayerSettings
  hud: GameHudView | null
  lastResult: RoundResult | null
  engineReady: boolean
  setScreen: (screen: AppScreen) => void
  setMode: (mode: GameModeId) => void
  setMapId: (mapId: string) => void
  patchSettings: (patch: Partial<PlayerSettings>) => void
  setHud: (hud: GameHudView | null) => void
  setResult: (result: RoundResult | null) => void
  setEngineReady: (ready: boolean) => void
}

export const useAppStore = create<AppState>((set, get) => ({
  screen: 'menu',
  mode: 'exit',
  mapId: null,
  settings: loadSettings(),
  hud: null,
  lastResult: null,
  engineReady: false,
  setScreen: (screen) => set({ screen }),
  setMode: (mode) => set({ mode }),
  setMapId: (mapId) => set({ mapId }),
  patchSettings: (patch) => {
    const settings = { ...get().settings, ...patch }
    saveSettings(settings)
    set({ settings })
  },
  setHud: (hud) => set({ hud }),
  setResult: (result) => set({ lastResult: result }),
  setEngineReady: (engineReady) => set({ engineReady }),
}))
